import React from "react";
import Card from "../Card/Card";
import "./Grid.css";

function Grid({ items = [], className = "" }) {
  if (!items.length) {
    return (
      <div className={`Grid Grid--empty ${className}`}>No projects yet.</div>
    );
  }
  return (
    <div className={`Grid ${className}`}>
      {items.map((item) => (
        <Card key={item.slug} item={item} />
      ))}
    </div>
  );
}

export default Grid;
